// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"57bc0eb12ca9456500cf","293":"511c252c4e162ac1fbae","518":"1f1e287faf6a1dd06714","779":"946deecf0317b9b179eb"}[chunkId] + ".js";
};